import { UserGroupIcon } from '@heroicons/react/24/outline';
import { InfoIcon } from 'lucide-react';

import { Container } from '@/components/legacy-ui';
import { Tooltip } from '@/components/Tooltip';
import { MONITORING_TOOLTIP_MAP } from '@/hooks/monitoringConstants';
import { MonitoringCounts, SubscriptionConfiguration } from '@/types';

import { CountBadge } from './CountBadge';
import { IncludedBadge } from './IncludedBadge';
import { NotIncludedBadge } from './NotIncludedBadge';

interface SocialEngineeringCardProps {
  monitoringCounts: MonitoringCounts;
  subscriptionValue?: SubscriptionConfiguration;
  isLoading: boolean;
}

export function SocialEngineeringCard({
  monitoringCounts,
  subscriptionValue,
  isLoading,
}: SocialEngineeringCardProps) {
  const socialEngineeringCovered = Boolean(
    subscriptionValue?.attackSurface?.users
  );
  const adUserCount = monitoringCounts.internalNetwork.ADUser || 0;

  return (
    <Container className="flex h-full w-full flex-col gap-3">
      <div className="mb-1 flex items-center justify-between">
        <h3 className="text-base font-semibold">Social Engineering</h3>
        {socialEngineeringCovered ? <IncludedBadge /> : <NotIncludedBadge />}
      </div>
      <div className="flex items-center gap-2">
        <UserGroupIcon className="text-chariot-stroke size-6 shrink-0" />
        <span className="text-sm font-medium whitespace-break-spaces">
          Users Monitored
        </span>
        <CountBadge value={adUserCount} isLoading={isLoading} />
      </div>
      <div className="bg-chariot-stroke h-px w-full" />
      <div className="flex flex-col gap-4">
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium whitespace-break-spaces capitalize">
              AD Users
            </span>
            <Tooltip title={MONITORING_TOOLTIP_MAP['ADUser'] || ''}>
              <InfoIcon
                className="text-chariot-text-primary size-4"
                aria-hidden="true"
              />
            </Tooltip>
          </div>
          <CountBadge value={adUserCount} isLoading={isLoading} />
        </div>
      </div>
    </Container>
  );
}
